import { createApi } from '@reduxjs/toolkit/query/react';
import { createSelector } from '@reduxjs/toolkit';

import qs from 'query-string';

import {
  ContentServiceBaseQuery,
  ConnectedContentServiceBaseQuery,
} from '../../common/services/httpClient';
// import { connectedContentApiEndpoints } from '../../common/services/connectedContentApi';
// import { workflowApiEndpoints } from '../workflow/workflowService';

export const insightsApi = createApi({
  reducerPath: 'insightApi',
  tagTypes: [
    'ContentList',
    'ContentItem',
    'ContentVersions',
    'ContentWorkflow',
  ],
  keepUnusedDataFor: 0,
  baseQuery: ContentServiceBaseQuery,
  endpoints: (build) => ({
    getInsights: build.query({
      query: ({ projectId, ...rest }) => ({
        url: `/projects/${projectId}/insights${
          Object.values(rest).length > 0 ? `?${qs.stringify(rest)}` : ''
        }`,
        method: 'GET',
      }),
      providesTags: ['ContentList'],
    }),
    getInsight: build.query({
      query: ({ projectId, insightId }) => ({
        url: `/projects/${projectId}/insights/${insightId}`,
        method: 'GET',
      }),
      providesTags: ['ContentItem'],
    }),
    postInsight: build.mutation({
      query: ({ projectId, contentId, step }) => ({
        url: `projects/${projectId}/workflow/${contentId}/${step}`,
        method: 'POST',
      }),
      invalidatesTags: [
        'ContentItem',
        'ContentVersions',
        'ContentWorkflow',
        'ContentList',
      ],
    }),
    getInsightVersions: build.query({
      baseQuery: ConnectedContentServiceBaseQuery,
      query: ({ projectId, contentThreadId }) => ({
        url: `projects/${projectId}/contents/${contentThreadId}/versions`,
        method: 'GET',
      }),
      providesTags: ['ContentVersions'],
    }),
    getWorkflowStatus: build.query({
      baseQuery: ContentServiceBaseQuery,
      query: ({ projectId, contentId }) => ({
        url: `/projects/${projectId}/workflow/${contentId}`,
        method: 'GET',
      }),
      providesTags: ['ContentWorkflow'],
    }),
    updateWorkflowStatus: build.mutation({
      baseQuery: ContentServiceBaseQuery,
      query: ({ projectId, contentId, step }) => ({
        url: `projects/${projectId}/workflow/${contentId}/${step}`,
        method: 'POST',
      }),
      invalidatesTags: ['ContentItem', 'ContentVersions', 'ContentWorkflow'],
    }),
  }),
});

// we combine the endpoints - for code re-usability
// also instead of  creating 1 big API file we split it in areas of concern
// so that when a mutation happens we can invalidate associated content in that area
// although combining all endpoints in one slice is also an option
// export const insightsApi = insightsApiBase
// TODO: raise a ticket with redux toolkit team regarding usage of split apis in testing
//   .injectEndpoints(connectedContentApiEndpoints)
//   .injectEndpoints(workflowApiEndpoints);

// Export hooks for usage in functional components, which are
// auto-generated based on the defined/injected endpoints
export const {
  useGetInsightsQuery,
  useGetInsightQuery,
  useGetInsightVersionsQuery,
  useUpdateWorkflowStatusMutation,
  useGetWorkflowStatusQuery,
} = insightsApi;

export const selectInsightsState = (state) => state.insightApi;

export const getCurrentInsight = createSelector(
  selectInsightsState,
  ({ queries = {} }) => {
    const { data } =
      Object.values(queries).find(
        ({ endpointName }) => endpointName === 'getInsight'
      ) || {};

    return data || {};
  }
);

export const getInsightId = createSelector(
  getCurrentInsight,
  ({ contentId }) => contentId
);
export const getInsightTitle = createSelector(
  getCurrentInsight,
  ({ title }) => title
);
